// Meta Pixel Events
export const trackMetaPixelEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    try {
      (window as any).fbq('track', eventName, data);
      console.log('📊 Meta Pixel Event:', eventName, data);
    } catch (error) {
      console.error('Meta Pixel Error:', error);
    }
  }
};

// TikTok Pixel Events
export const trackTikTokPixelEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && (window as any).ttq) {
    try {
      (window as any).ttq.track(eventName, data);
      console.log('📊 TikTok Pixel Event:', eventName, data);
    } catch (error) {
      console.error('TikTok Pixel Error:', error);
    }
  }
};

// Combined tracking function
export const trackEvent = (eventName: string, data?: any) => {
  trackMetaPixelEvent(eventName, data);
  trackTikTokPixelEvent(eventName, data);
};

// E-commerce specific events
export const trackViewContent = (product: any) => {
  const data = {
    content_name: product.name,
    content_ids: [product.id],
    content_type: 'product',
    value: product.price,
    currency: 'EGP',
  };
  trackEvent('ViewContent', data);
};

export const trackAddToCart = (product: any, quantity: number) => {
  const data = {
    content_name: product.name,
    content_ids: [product.id],
    content_type: 'product',
    value: product.price * quantity,
    currency: 'EGP',
    quantity: quantity,
  };
  trackEvent('AddToCart', data);
};

export const trackInitiateCheckout = (items: any[], total: number) => {
  const data = {
    content_ids: items.map(item => item.product.id),
    contents: items.map(item => ({
      id: item.product.id,
      quantity: item.quantity,
      price: item.product.price,
    })),
    value: total,
    currency: 'EGP',
    num_items: items.length,
  };
  trackEvent('InitiateCheckout', data);
};

export const trackPurchase = (orderId: string, items: any[], total: number) => {
  const data = {
    content_ids: items.map(item => item.product.id),
    contents: items.map(item => ({
      id: item.product.id,
      quantity: item.quantity,
      price: item.product.price,
    })),
    value: total,
    currency: 'EGP',
    num_items: items.length,
    order_id: orderId,
  };
  trackEvent('Purchase', data);
};

export const trackSearch = (searchQuery: string) => {
  const data = {
    search_string: searchQuery,
  };
  trackEvent('Search', data);
};
